import styled from 'styled-components';

import { breakpoints, PictogramRegularBrand, theme } from '@notino/react-styleguide-v20';

export const StyledHeader = styled.div`
  display: flex;
  z-index: 10;
  align-items: center;
  background-color: ${theme.color.background.inverse};
  color: ${theme.color.text.inverse};
  padding: 0.6875rem 0.9375rem;
  position: sticky;
  top: 0;

  @media (min-width: ${breakpoints.md}) {
    padding: 1.5625rem 2.5rem;
  }
`;

export const StyledLogo = styled.a`
  margin-right: 0.9375rem;
  height: 1.5rem;
  @media (min-width: ${breakpoints.md}) {
    margin-right: 3.125rem;
    height: 1.5625rem;
  }
`;

export const StyledLogoIcon = styled(PictogramRegularBrand)`
  max-width: 7rem;
  height: 1.5rem;
  @media (min-width: ${breakpoints.md}) {
    max-width: 9rem;
    height: 1.5625rem;
  }
`;

export const StyledText = styled.div`
  font-size: 0.7rem;
  margin-right: 2rem;
  @media (min-width: ${breakpoints.md}) {
    display: inline-block;
    margin-right: 1rem;
    font-size: 0.8125rem;
  }
`;
